// Yup
import { object, string } from 'yup';

const addressSchema = object().shape({
  cep: string()
    .required('Campo CEP obrigatório')
    .matches(/^([0-9]){5}-?([0-9]){3}$/g, { message: 'Digite um CEP válido' }),
  street: string().required('Campo rua obrigatório'),
  number: string().required('Campo número obrigatório'),
  compl: string(),
  neigh: string().required('Campo bairro obrigatório'),
  city: string().required('Campo cidade obrigatório'),
  state: string().required('Campo Estado obrigatório'),
});

export { addressSchema };
export default addressSchema;
